import React, { RefObject } from 'react';
import { RecoilState, useRecoilState } from 'recoil';
import { TablePagination } from '@tq/ui-components';

import { PaginationInfo } from 'types';

type ReportPaginationProps = {
  paginationInfo: PaginationInfo | undefined;
  pageNumberState: RecoilState<number>;
  pageSizeState: RecoilState<number>;
  tableRef: RefObject<HTMLElement>;
  tableScrollHeaderOffset: number;
};

export const DataTablePagination: React.FC<ReportPaginationProps> = ({
  paginationInfo,
  pageNumberState,
  pageSizeState,
  tableRef,
  tableScrollHeaderOffset,
}) => {
  const [pageNumber, setPageNumber] = useRecoilState(pageNumberState);
  const [pageSize, setPageSize] = useRecoilState(pageSizeState);

  const setPage = (newPageNumber: number) => {
    if (
      newPageNumber !== pageNumber &&
      newPageNumber >= 1 &&
      newPageNumber <= (paginationInfo?.totalPages ?? 1)
    ) {
      setPageNumber(newPageNumber);
      if (tableRef?.current) {
        window.scrollTo({ top: tableRef.current.offsetTop - tableScrollHeaderOffset });
      }
    }
  };

  const nextPage = () => setPage(pageNumber + 1);
  const previousPage = () => setPage(pageNumber - 1);

  const gotoPage = (value: ((pageIndex: number) => number) | number) => {
    const page = typeof value === 'number' ? value : value(pageNumber);
    setPage(page + 1);
  };

  const maxPages: number = paginationInfo?.totalPages || 0;

  return (
    <>
      {paginationInfo && paginationInfo.totalCount >= 11 && (
        <TablePagination
          pageCount={maxPages}
          pageIndex={pageNumber - 1}
          pageSize={pageSize}
          setPageSize={setPageSize}
          previousPage={previousPage}
          nextPage={nextPage}
          gotoPage={gotoPage}
          pageOptions={[]}
        />
      )}
    </>
  );
};
